import { Haptics, ImpactStyle, NotificationType } from "@capacitor/haptics";
import { WebHaptics, defaultPatterns } from "web-haptics";
import { CAP_IS_NATIVE } from "../env";

// Web haptics instance (handles both Android vibrate API + iOS switch checkbox hack)
let webHaptics: WebHaptics | null = null;

function getWebHaptics(): WebHaptics {
  if (!webHaptics) {
    webHaptics = new WebHaptics();
  }
  return webHaptics;
}

export function hapticLight() {
  if (CAP_IS_NATIVE) {
    Haptics.impact({ style: ImpactStyle.Light }).catch(() => {});
  } else {
    getWebHaptics().trigger(defaultPatterns.light).catch(() => {});
  }
}

export function hapticMedium() {
  if (CAP_IS_NATIVE) {
    Haptics.impact({ style: ImpactStyle.Medium }).catch(() => {});
  } else {
    getWebHaptics().trigger(defaultPatterns.medium).catch(() => {});
  }
}

export function hapticHeavy() {
  if (CAP_IS_NATIVE) {
    Haptics.impact({ style: ImpactStyle.Heavy }).catch(() => {});
  } else {
    getWebHaptics().trigger(defaultPatterns.heavy).catch(() => {});
  }
}

export function hapticSuccess() {
  if (CAP_IS_NATIVE) {
    Haptics.notification({ type: NotificationType.Success }).catch(() => {});
  } else {
    getWebHaptics().trigger(defaultPatterns.success).catch(() => {});
  }
}

export function hapticError() {
  if (CAP_IS_NATIVE) {
    Haptics.notification({ type: NotificationType.Error }).catch(() => {});
  } else {
    getWebHaptics().trigger(defaultPatterns.error).catch(() => {});
  }
}
